
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class Error
 * @hideconstructor
 * @classdesc Generic class to hold information regarding errors
 */
define([], () => {
	const ERROR = 'error';
	const WARNING = 'warning';

	class ApiError {
		constructor(message, options) {
			this._message = message.msg;
			this._params = message.params;
			this._type = (options && options.type === WARNING) ? WARNING : ERROR;
		}

		/**
		 * @function Error#getMessage
		 * @return {String} get the description of the error
		 */
		getMessage() {
			return this._message;
		}

		/**
		 * @function Error#getParams
		 * @return {String} get the parameters of the error
		 */
		getParams() {
			return this._params;
		}

		/**
		 * @function Error#getType
		 * @return {String} get the type of the error
		 */
		getType() {
			return this._type;
		}

		/**
		 * @function Error#toJson
		 * @return {String} the spec of the error object
		 */
		toJson() {
			return {
				message: this.getMessage(),
				params: this.getParams(),
				type: this.getType()
			};
		}

	}

	return ApiError;
});
